module.exports = __webpack_public_path__ + "img/pre_registration_bg.c2e4798f.png";